import apiFetch from '../apiFetch'

export default function (token, documentTypeUse) {
  return apiFetch({ endPoint: `DocumentTypeUse/${documentTypeUse.documentTypeUseId}`, method: 'DELETE', body: null, token: token })
}
